// extracted by mini-css-extract-plugin
export default {"freeSpins":"FreeSpinsBlock_freeSpins__ZrOe9"};